var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGargantuaDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10132_25285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.665 9.99996C18.665 14.7855 14.7855 18.665 9.99996 18.665C5.21441 18.665 1.33496 14.7855 1.33496 9.99996C1.33496 5.21441 5.21441 1.33496 9.99996 1.33496C14.7855 1.33496 18.665 5.21441 18.665 9.99996Z",
    stroke: "#4B505A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 5,
    fill: "url(#paint0_linear_10132_25285)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10132_25285",
    x1: 15,
    y1: 10,
    x2: 5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CD1E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F71CFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10132_25285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGargantuaDark);
export default __webpack_public_path__ + "static/media/gargantua-dark.8b3309bf3bbd0454107f4c920134ca5d.svg";
export { ForwardRef as ReactComponent };